import { useRef, useState } from 'react'

import { noop } from '@tribeplatform/react-ui-kit/hooks'

const DEFAULT_TIMEOUT = 2000

const setClipboard = async (content?: BlobPart) => {
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([content || ''], {
          type: 'text/html',
        }),
      }),
    ])
  } catch (error) {
    noop(error)
  }
}

interface Props {
  content?: BlobPart
  timeout?: number
}

export const useCopyToClipboard = ({
  content,
  timeout = DEFAULT_TIMEOUT,
}: Props) => {
  const [copied, setCopied] = useState(false)
  const timeoutHandle = useRef<NodeJS.Timeout>(null)

  const copyToClipboard = async () => {
    await setClipboard(content)
    setCopied(true)
    clearTimeout(timeoutHandle.current)
    timeoutHandle.current = setTimeout(() => setCopied(false), timeout)
  }

  return {
    copied,
    copyToClipboard,
  }
}
